<template>
  <div
    class="login-form"
  >
    <form
      id="new_customer"
      class="simple_form second-account-form checkout-login"
      novalidate="novalidate"
      action="/customers/sign_in"
      accept-charset="UTF-8"
      data-remote="true"
      method="post"
    >
      <input
        name="utf8"
        type="hidden"
        value="✓"
      >
      <div class="form-group">
        <input
          id="customer_email"
          v-validate="{required: true}"
          :value="email"
          type="hidden"
          name="customer[email]"
        >
        <p>{{ $t('checkout.payment.preexistingAccount') }}</p>
        <input
          id="customer_password"
          autocomplete="off"
          :placeholder="$t('form.password')"
          class="form-control password second-account-form-password"
          type="password"
          name="customer[password]"
        >
        <div class="response" />
      </div>
      <div class="form-group submit">
        <input
          id="loginBtn"
          type="submit"
          name="commit"
          value="Log In"
          class="btn btn-primary login-btn"
          data-disable-with="submit"
        >
      </div>
    </form>
    <div class="forgot-password-link">
      <a href="/customers/password/new">{{ $t('forgotYourPassword') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['email']
}
</script>
